var _path, _path2, _circle, _circle2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 5.625H16.875V5C16.875 3.27688 15.4731 1.875 13.75 1.875H6.25C4.52688 1.875 3.125 3.27688 3.125 5V5.625H2.8125C1.95063 5.625 1.25 6.32625 1.25 7.1875V8.75C1.25 9.095 1.52938 9.375 1.875 9.375C2.22062 9.375 2.5 9.095 2.5 8.75V7.1875C2.5 7.015 2.64062 6.875 2.8125 6.875H3.125V13.125C3.125 14.1425 3.62125 15.0394 4.37625 15.61C4.37625 15.615 4.375 15.62 4.375 15.625V16.875C4.375 17.5656 4.93438 18.125 5.625 18.125H6.25C6.94063 18.125 7.5 17.5656 7.5 16.875V16.25H12.5V16.875C12.5 17.5656 13.0594 18.125 13.75 18.125H14.375C15.0656 18.125 15.625 17.5656 15.625 16.875V15.625C15.625 15.62 15.6237 15.615 15.6237 15.61C16.3787 15.0387 16.875 14.1425 16.875 13.125V6.875H17.1875C17.3594 6.875 17.5 7.015 17.5 7.1875V8.75C17.5 9.095 17.7794 9.375 18.125 9.375C18.4706 9.375 18.75 9.095 18.75 8.75V7.1875C18.75 6.32625 18.0494 5.625 17.1875 5.625ZM5.9375 14.375C5.42 14.375 5 13.955 5 13.4375C5 12.92 5.42 12.5 5.9375 12.5C6.455 12.5 6.875 12.92 6.875 13.4375C6.875 13.955 6.455 14.375 5.9375 14.375ZM14.0625 14.375C13.545 14.375 13.125 13.955 13.125 13.4375C13.125 12.92 13.545 12.5 14.0625 12.5C14.58 12.5 15 12.92 15 13.4375C15 13.955 14.58 14.375 14.0625 14.375ZM15.625 9.04688C15.625 9.6575 15.1856 10.1894 14.5819 10.2806C13.0981 10.5037 11.5675 10.6237 10 10.6237C8.4325 10.6237 6.90188 10.5044 5.41812 10.2806C4.81437 10.1894 4.375 9.6575 4.375 9.04688V5.625C4.375 4.93438 4.93438 4.375 5.625 4.375H14.375C15.0656 4.375 15.625 4.93438 15.625 5.625V9.04688Z",
    fill: "url(#paint0_linear_115_4808)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6C5 5.44772 5.44772 5 6 5H14C14.5523 5 15 5.44772 15 6V8.56676C15 9.0689 14.6267 9.49423 14.1281 9.55392C10.8114 9.95097 8.74339 9.95542 5.85226 9.56656C5.36215 9.50064 5 9.07886 5 8.58433V6Z",
    fill: "url(#paint1_linear_115_4808)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.94618,
    cy: 13.4442,
    r: 0.555556,
    fill: "url(#paint2_linear_115_4808)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0556,
    cy: 13.4442,
    r: 0.555556,
    fill: "url(#paint3_linear_115_4808)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_4808",
    x1: 1.25,
    y1: 10,
    x2: 18.75,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_115_4808",
    x1: 5,
    y1: 7.42749,
    x2: 15,
    y2: 7.42749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_115_4808",
    x1: 5.39062,
    y1: 13.4442,
    x2: 6.50174,
    y2: 13.4442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_115_4808",
    x1: 13.5,
    y1: 13.4442,
    x2: 14.6111,
    y2: 13.4442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.09a740a15d21928a39471838b9789ae3.svg";
export { ForwardRef as ReactComponent };